import { Navigate } from 'react-router-dom';
import { ReactNode } from 'react';
import { useAuth } from '@/hooks/useAuth';

interface PublicRouteProps {
  children: ReactNode;
}

export function PublicRoute({ children }: PublicRouteProps) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center space-y-4">
          <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto"></div>
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (user) {
    switch (user.role) {
      case 'admin':  return <Navigate to="/admin/dashboard" replace />;
      case 'club':   return <Navigate to="/club/dashboard" replace />;
      case 'ngo':    return <Navigate to="/ngo/dashboard" replace />;
      case 'player': return <Navigate to="/player/dashboard" replace />;
      default:       return <Navigate to="/login" replace />;
    }
  }

  return <>{children}</>;
}
